import appStore from "store";
import api from "./api";

const store = {
  namespaced: true,
  state: {
    codelist: [],
    updatePosterDialog: false,
    totalCount: 0,
  },
  getters: {
   filterList:state=>state.codelist
  },
  mutations: {
    setcodelist(state, payload) {
      state.codelist = payload;
    },
    setupdatePosterDialog(state, payload) {
      state.updatePosterDialog = payload;
    },
    setTotalCount(state,payload){
      state.totalCount=payload
    }
  },
  actions: {
   async getlist({ commit }, params) {
     const res=await api.getCodeList(params)
     commit("setcodelist", res.data.list);
     commit('setTotalCount',res.data.totalCount)
    return res
    },
    async delOne({ commit }, id) {
      const res = await api.delOneCountryCode(id);
      return res;
    },
    async addOne({ commit }, data) {
      const res = await api.addOneCountry(data);
      return res;
    },
  async  updateOne({commit},data){
      const res=await api.updateCode(data)
      return res
    }

  },
};

appStore.registerModule("countryCode", store);
